import {fetch} from 'wix-fetch';
// The code in this file will load on every page of your site

$w.onReady(function () {
	// Write your code here
});

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button16_click(event) {
	 fetch('https://bh-nest-services-staging.herokuapp.com/email', {
	    method: 'POST',
    	headers: {
      	'Accept': 'application/json',
      	'Content-Type': 'application/json'
    	},
    		body: JSON.stringify({name: `${$w('#input7').text} ${$w('#input8').text}`, email: $w('#input2').text })
  		});
}